import dayjs from 'dayjs';
import 'dayjs/locale/it';

dayjs.locale('it');

/**
 * Utility function to translate role names to Italian
 * @param {string} role - The role name
 * @returns {string} - The Italian translation
 */
const getRoleLabel = (role) => {
  switch (role) {
    case 'admin':
      return 'Amministratore';
    case 'teacher':
      return 'Docente';
    case 'member':
      return 'Membro';
    default:
      return role;
  }
};

/**
 * Formats a date to 'DD-MMM-YY' format (e.g., '25-lug-25')
 * @param {Date|string} date - The date to format
 * @returns {string} - Formatted date or empty string
 */
const formatDate = (date) => {
  if (!date) return '';
  return dayjs(date).locale('it').format('DD-MMM-YY').toLowerCase();
};

/**
 * Escapes CSV values that contain commas, quotes, or newlines
 * @param {any} value - The value to escape
 * @returns {string} - Escaped CSV value
 */
const escapeCSV = (value) => {
  if (value === null || value === undefined) return '';
  const stringValue = String(value);
  if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
};

/**
 * Exports users data to CSV file
 * @param {Array} users - Array of user objects
 */
export const exportUsersToCSV = (users) => {
  // CSV Headers
  const headers = [
    'ID',
    'Nome',
    'Cognome',
    'Email',
    'Telefono',
    'Telefono Secondario',
    'Taglia Maglietta',
    'Ruoli',
    'Statuto Firmato',
    'Privacy Firmata',
    'Foto',
    'Anno di Corso',
    'Primo Accesso',
    'Data Creazione'
  ];
  
  // Convert users to CSV rows
  const csvRows = users.map(user => {
    // Handle multiple roles
    const roles = user.roles || [];
    const rolesLabel = roles.map(role => getRoleLabel(role)).join(' / ') || '';
    
    // Handle course year
    const isMember = user.roles?.includes('member');
    let levelValue = '';
    if (isMember) {
      if (user.level === 0 || user.level === null || user.level === undefined) {
        levelValue = 'Da assegnare';
      } else if (user.level >= 6) {
        levelValue = 'Oltre il 5° anno';
      } else {
        levelValue = `${user.level}° anno`;
      }
    } else {
      levelValue = '';
    }
    
    return [
      user._id || '',
      user.name || '',
      user.surname || '',
      user.email || '',
      user.telephone || '',
      user.telephoneSecondary || '',
      user.shirtSize || '',
      rolesLabel,
      user.flagStatuto ? 'Si' : 'No',
      user.flagPrivacy ? 'Si' : 'No',
      user.flagPicture ? 'Si' : 'No',
      levelValue,
      user.isFirstLogin ? 'Si' : 'No',
      formatDate(user.createdAt)
    ];
  });
  
  // Create CSV content
  const csvContent = [
    headers.map(escapeCSV).join(','),
    ...csvRows.map(row => row.map(escapeCSV).join(','))
  ].join('\n');
  
  // Create blob and download file
  const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `utenti_${dayjs().format('YYYY-MM-DD')}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

